import { render } from "./Contact.vue?vue&type=template&id=fd4f7f78"
import script from "./Contact.vue?vue&type=script&lang=ts"
export * from "./Contact.vue?vue&type=script&lang=ts"
script.render = render

export default script